export const routesName = {
  LANDING: "landing",
  FIND_APPOINTMENT: "findappointment",
  ADDITIONAL_DETAILS: "additionaldetails",
  INSURANCE: "insurance",
  IDENTITY: "identity",
  // EXITING_PATIENT_FIND_APPOINTMENT: "exiting-patient/findappointment",
  THANKYOU: "thankyou",
  WIDGET: "widget",

  //Admin
  ADMIN_LOGIN: "login",
  ADMIN_MANAGE_SCHEDULER: "managescheduler",
  ADMIN_PROVIDER_CONTROL: "providercontrol",
  ADMIN_PROVIDER_EDIT_CONTROL: "providercontroleditprovider",
  ADMIN_WAIT_LIST: "waitlist",
  ADMIN_SERVICE_CONTROL: "configservices",
  ADMIN_INSURANCE_CONTROL: "insuranceconfig",
  ADMIN_LOCATION_CONTROL: "locationconfig",
  ADMIN_REPORTS: "reports",
  ADMIN_WIDGET: "widget",
  ADMIN_BLANK: "blank",
};
